import type { PlayerNotesComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const playerNotesDuplicate: DuplicationHandler<PlayerNotesComponentSpec> = (spec) => {
  spec.queryId = crypto.randomUUID();
};
